import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
const HopperRestaurantSpecials = ({ components }) => {
    const getDataIetm = (component) => {
        return (
            component?.Data?.map((val, key) => {
                return (
                    <div className="HopperRestaurantSpecials-card" key={key}>
                        <div className="HopperRestaurantSpecials-card-count">
                            <img alt="" src={val.icon} />
                        </div>
                        <div className="HopperRestaurantSpecials-card-cont">
                            <div className="HopperRestaurantSpecials-card-cont-header">{val?.header}</div>
                            <div className="HopperRestaurantSpecials-card-cont-subheader">{val?.subheader}</div>
                        </div>
                    </div>
                )
            })
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HopperRestaurantSpecials-card":
                return getDataIetm(component)

            default:
                return <div />
        }

    }
    return (
        <div className="HopperRestaurantSpecials">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}

        </div>
    )
}
export default HopperRestaurantSpecials